__turbopack_context__.v({
  "card": "game-stats-card-module-scss-module__hb4xjG__card",
  "cardBody": "game-stats-card-module-scss-module__hb4xjG__cardBody",
  "cardDivider": "game-stats-card-module-scss-module__hb4xjG__cardDivider",
  "cardHeader": "game-stats-card-module-scss-module__hb4xjG__cardHeader",
  "cardHeaderRow": "game-stats-card-module-scss-module__hb4xjG__cardHeaderRow",
  "cardTitle": "game-stats-card-module-scss-module__hb4xjG__cardTitle",
  "cardsRow": "game-stats-card-module-scss-module__hb4xjG__cardsRow",
  "emptyProgress": "game-stats-card-module-scss-module__hb4xjG__emptyProgress",
  "emptyThumbImage": "game-stats-card-module-scss-module__hb4xjG__emptyThumbImage" + " " + "game-stats-card-module-scss-module__hb4xjG__thumbPlaceholderImage",
  "gameTitle": "game-stats-card-module-scss-module__hb4xjG__gameTitle",
  "infoButton": "game-stats-card-module-scss-module__hb4xjG__infoButton",
  "infoIcon": "game-stats-card-module-scss-module__hb4xjG__infoIcon",
  "list": "game-stats-card-module-scss-module__hb4xjG__list",
  "listHost": "game-stats-card-module-scss-module__hb4xjG__listHost",
  "listScrollFade": "game-stats-card-module-scss-module__hb4xjG__listScrollFade",
  "listScrollable": "game-stats-card-module-scss-module__hb4xjG__listScrollable",
  "listScrollableContent": "game-stats-card-module-scss-module__hb4xjG__listScrollableContent",
  "listScrollbar": "game-stats-card-module-scss-module__hb4xjG__listScrollbar",
  "metric": "game-stats-card-module-scss-module__hb4xjG__metric",
  "metricPct": "game-stats-card-module-scss-module__hb4xjG__metricPct",
  "metricValue": "game-stats-card-module-scss-module__hb4xjG__metricValue",
  "progressBar": "game-stats-card-module-scss-module__hb4xjG__progressBar",
  "row": "game-stats-card-module-scss-module__hb4xjG__row",
  "rowAccent": "game-stats-card-module-scss-module__hb4xjG__rowAccent",
  "rowActive": "game-stats-card-module-scss-module__hb4xjG__rowActive",
  "rowMeta": "game-stats-card-module-scss-module__hb4xjG__rowMeta",
  "skeletonMeta": "game-stats-card-module-scss-module__hb4xjG__skeletonMeta",
  "skeletonRow": "game-stats-card-module-scss-module__hb4xjG__skeletonRow",
  "skeletonThumb": "game-stats-card-module-scss-module__hb4xjG__skeletonThumb",
  "skeletonTitle": "game-stats-card-module-scss-module__hb4xjG__skeletonTitle",
  "skeletonValue": "game-stats-card-module-scss-module__hb4xjG__skeletonValue",
  "thumb": "game-stats-card-module-scss-module__hb4xjG__thumb",
  "thumbImage": "game-stats-card-module-scss-module__hb4xjG__thumbImage",
  "thumbPlaceholder": "game-stats-card-module-scss-module__hb4xjG__thumbPlaceholder",
  "thumbPlaceholderImage": "game-stats-card-module-scss-module__hb4xjG__thumbPlaceholderImage",
});
